var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12,4.84c.84,0,1.56-.5,1.9-1.22.12-.27.2-.56.2-.87,0-.12-.02-.24-.04-.35-.17-.99-1.02-1.74-2.06-1.74s-1.89.76-2.06,1.74c-.02.11-.04.23-.04.35,0,.31.07.61.2.87.33.72,1.05,1.22,1.9,1.22Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 10.7,
  y: 6.69,
  width: 2.59,
  height: 10.61,
  rx: 0.65,
  ry: 0.65
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.21,3.32l-.87,1.58c2.24,1.44,3.74,3.95,3.74,6.8,0,4.45-3.62,8.08-8.08,8.08S3.92,16.16,3.92,11.71c0-2.86,1.49-5.37,3.74-6.8l-.87-1.58c-2.8,1.75-4.68,4.85-4.68,8.38,0,5.45,4.43,9.88,9.88,9.88s9.88-4.43,9.88-9.88c0-3.54-1.87-6.64-4.68-8.38Z"
})));
export default SvgInfoIcon;